'use strict';

var classes = {"progress-label":"progress-label__W0e8z"};

module.exports = classes;
//# sourceMappingURL=base-progress.module.scss.js.map
